import React from 'react';

// Export SVG string for print templates (PDF generation)
export const BRAND_LOGO_SVG_STRING = `
<svg width="80" height="80" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="display:block; margin: 0 auto;">
  <path d="M50 85 L20 50 C5 35 5 15 25 10 C40 5 50 25 50 25 C50 25 60 5 75 10 C95 15 95 35 80 50 Z" fill="#d4b978" />
  <polyline points="15,50 30,50 40,20 50,80 60,35 70,50 85,50" fill="none" stroke="#3f583f" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`;

interface BrandLogoProps {
  className?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Gold Heart */}
    <path d="M50 85 L20 50 C5 35 5 15 25 10 C40 5 50 25 50 25 C50 25 60 5 75 10 C95 15 95 35 80 50 Z" fill="#d4b978" />
    {/* Sage Green Pulse Line */}
    <polyline points="15,50 30,50 40,20 50,80 60,35 70,50 85,50" fill="none" stroke="#3f583f" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default BrandLogo;